import {Util} from 'yougile-util'
import {
  DataObject,
  dataObjectDefaultValues,
  DataObjectId,
  DataObjectJSON
} from './data-object'

export interface EntityJSON extends DataObjectJSON {
  title: string
  location: DataObjectId

  description?: string
  sync?: boolean
  apiData?: any

  /**
   * Location history, undefined if task was never moved.
   * location => [timestamps]
   */
  locHistory?: {[locationId: string]: number[]}
}

export const isEntityJSON = (obj: DataObjectJSON): obj is EntityJSON => {
  return !!(obj as EntityJSON)?.location
}

export const entityDefaultValues = {
  ...dataObjectDefaultValues,
  description: '',
  location: '',
  sync: false
} as const

export abstract class Entity extends DataObject {
  public description!: string
  public location!: DataObjectId
  public title: string
  public sync!: boolean
  public apiData: any

  constructor(companyId: DataObjectId, title: string) {
    super(companyId)
    this.title = title

    let lastProto = Object.getPrototypeOf(this)
    while (
      lastProto.__proto__ &&
      lastProto.__proto__ !== Object.prototype &&
      lastProto.__proto__ !== entityDefaultValues
    ) {
      lastProto = lastProto.__proto__
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    lastProto.__proto__ = entityDefaultValues
  }

  public override toJSON(): EntityJSON {
    const res = super.toJSON() as EntityJSON
    res.title = this.title
    res.location = this.location

    if (res.deleted && !!res.properties?.del && res.title !== res.id) {
      delete res.properties.del
    }
    if (this.description) {
      res.description = this.description
    }
    if (this.sync) {
      res.sync = true
    }
    if (this.apiData) {
      res.apiData = Util.clone(this.apiData)
    }
    return res
  }

  public override fromJSON(companyId: DataObjectId, data: EntityJSON): Entity {
    super.fromJSON(companyId, data)
    this.title = data.title || this.id
    this.location = data.location
    if (data.description) {
      this.description = data.description
    }
    if (data.sync) {
      this.sync = data.sync
    }
    if (data.apiData) {
      this.apiData = Util.clone(data.apiData)
    }
    return this
  }

  public override toString(): {qwe: number} {
    throw new Error('TODO!!!!!!!!')
  }

  public isHidden(): boolean {
    // todo: make this more solid (user can create task starting with .)
    return this.title?.startsWith('.')
  }
}
